import { format } from 'date-fns';
import type { FC } from 'react';

const DATE_FORMAT = 'yyyy-MM-dd hh:mm a';

interface NonBreakingDateProps {
	date: string;
}

export const NonBreakingDate: FC<NonBreakingDateProps> = ({ date }) => {
	const [datePart, timePart, postfixPart] = format(new Date(date), DATE_FORMAT).split(
		' ',
	);

	return (
		<>
			<span className="whitespace-nowrap">{`${datePart},`}</span>&nbsp;
			<span className="whitespace-nowrap">{`${timePart} ${postfixPart}`}</span>
		</>
	);
};
